export default "__VITE_ASSET__10234358__"